import React from 'react';
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
} from '@mui/material';
import {
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
} from '@mui/icons-material';
import FeedbackTableRow from './FeedbackTableRow';
import PropTypes from 'prop-types';

/**
 * FeedbackTable Component
 * Table displaying feedback with sortable columns
 */
const FeedbackTable = ({ feedback, sortBy, sortOrder, onSort }) => {
  const renderSortIcon = column => {
    if (sortBy !== column) {
      return null;
    }
    return sortOrder === 'asc' ? (
      <ArrowUpwardIcon
        fontSize="small"
        sx={{ ml: 0.5, verticalAlign: 'middle' }}
      />
    ) : (
      <ArrowDownwardIcon
        fontSize="small"
        sx={{ ml: 0.5, verticalAlign: 'middle' }}
      />
    );
  };

  return (
    <TableContainer component={Paper} elevation={1}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Box
                display="flex"
                alignItems="center"
                sx={{ cursor: 'pointer', userSelect: 'none' }}
                onClick={() => onSort('rating')}
              >
                Rating
                {renderSortIcon('rating')}
              </Box>
            </TableCell>
            <TableCell>
              <Box
                display="flex"
                alignItems="center"
                sx={{ cursor: 'pointer', userSelect: 'none' }}
                onClick={() => onSort('created_at')}
              >
                Date
                {renderSortIcon('created_at')}
              </Box>
            </TableCell>
            <TableCell>Version</TableCell>
            <TableCell>Feedback Text</TableCell>
            <TableCell>Categories</TableCell>
            <TableCell>Execution ID</TableCell>
            <TableCell>Created By</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {feedback.map(item => (
            <FeedbackTableRow key={item.id} feedback={item} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

FeedbackTable.propTypes = {
  feedback: PropTypes.array.isRequired,
  sortBy: PropTypes.string.isRequired,
  sortOrder: PropTypes.string.isRequired,
  onSort: PropTypes.func.isRequired,
};

export default FeedbackTable;
